import React, { useEffect, useState } from 'react';
import { BannerWrapper, Wrapper } from './styled';
import Layout from '../../components/Layout';
import { Link, useParams } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import { useRecoilState, useRecoilValue } from 'recoil';
import { seriresAtom, seriresNumAtom, shuffleAtom } from '../../atom/taxonomy';
import { GetPosts, GetSeriesNum, GetTags } from '../../service/blog';
import {
	SkeletonBanner,
	SkeletonList,
	SkeletonMoBanner,
	SkeletonSeriesWrap,
	SkeletonWriter,
} from '../../components/Skeleton';

const Writer = () => {
	const params = useParams();
	const series = useRecoilValue(seriresAtom);

	console.log(series, 123);

	console.log(params?.ID, 77);

	const [paged, setPaged] = useState(1);
	const postsPerPage = 8;
	const [items, setItems] = useState([]);
	const [total, setTotal] = useState(0);
	const [maxPaged, setMaxPaged] = useState(1);
	const [authorInfo, setAuthorInfo] = useState({});

	useEffect(() => {
		GetPosts({
			paged,
			postsPerPage,
			authorId: params?.id,
		})
			.then((res) => {
				console.log(res);
				if (res.data.code == 200) {
					setItems(res.data.body.items);
					setTotal(res.data.body.total);
					setMaxPaged(res.data.body.maxPaged);
					setAuthorInfo(res.data.body.authorInfo);
				} else {
					setItems(null);
					setAuthorInfo(res.data.body.authorInfo);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, [paged]);

	const onPaging = (page) => {
		console.log(page);
		// router.push(
		// 	'/products/' +
		// 		(paged.category_ID ? paged.category_ID + '/' : '') +
		// 		'?paged=' +
		// 		page
		// );
		window.scrollTo(0, 0);
		setItems(null);
		setPaged(page);
	};

	const [tags, setTags] = useState([]);

	useEffect(() => {
		GetTags({
			series: params?.ID,
		})
			.then((res) => {
				if (res.data.code == 200) {
					setTags(res.data.body.result);
				} else {
					setTags(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const [seriesNum, setSeriesNum] = useRecoilState(seriresNumAtom);
	const [shuffle, setShuffle] = useRecoilState(shuffleAtom);

	function shuffleArray(array) {
		const shuffledArray = [...array]; // Create a copy of the original array
		for (let i = shuffledArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledArray[i], shuffledArray[j]] = [
				shuffledArray[j],
				shuffledArray[i],
			];
		}
		return shuffledArray;
	}

	useEffect(() => {
		const shuffledObjects = shuffleArray(shuffle);
		console.log(77, shuffledObjects);
		setShuffle(shuffledObjects);
		GetSeriesNum({})
			.then((res) => {
				console.log(res);

				const sortedObjects = [...res.data.body.array]; // Create a copy of the array
				sortedObjects.sort((a, b) => b.value - a.value); // Sort by 'count' in ascending order

				console.log(123, sortedObjects);
				setSeriesNum(sortedObjects);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	return (
		<Layout>
			<title>{authorInfo?.postAuthorName} KB데이타시스템 공식블로그</title>
			<meta
				name="description"
				content={`${authorInfo?.postAuthorName} 님의 ${total}개의 포스트`}
			/>
			<Wrapper>
				<div className="flex-wrapper">
					<div className="left">
						{authorInfo ? (
							<div className="writer">
								<div className="writer-user-box">
									<div className="bg"></div>
									<div className="user-flex">
										<div className="user-left">
											<div className="user-img">
												<div
													className="user"
													style={{
														backgroundImage: `url(${authorInfo?.postAuthorImg})`,
													}}
												></div>
											</div>
											<div className="user-name">
												<h3>{authorInfo?.postAuthorName}</h3>
												<p>{authorInfo?.department}</p>
											</div>
										</div>
										<a href="/pocketlist" className="user-right">
											<p>글쓴이 더보기</p>
											<img src="/images/icon-author.svg" alt="" />
										</a>
									</div>
								</div>
								<div className="under-article-box">
									<div className="under-article">
										<div className="article-left">
											<h2>{total}</h2>
											<p>작성 아티클</p>
										</div>
										<div className="mo-article-left">
											<div className="flex">
												<h2>{total}</h2>
												<p>작성 아티클</p>
											</div>
											<a href="/pocketlist" className="mo-right">
												<p>글쓴이 더보기</p>
												<img src="/images/icon-author02.svg" alt="" />
											</a>
										</div>
										<div className="article-right">
											<p className="cont">{authorInfo?.intro}</p>
										</div>
									</div>
								</div>
							</div>
						) : (
							<SkeletonWriter />
						)}
						<div className="total">
							<p>
								총 <span>{total}</span>개의 아티클이 있습니다.
							</p>
						</div>
						{!items ? (
							<>
								<div className="result">
									<div className="result-box">
										<p>
											작성된 아티클이 없어요
											<br /> 아티클을 작성해보세요!
										</p>
									</div>
								</div>
							</>
						) : items?.length ? (
							<div className="article-wrap">
								<h2 className="title">{series[params?.ID]?.title}</h2>
								<div className="flex-wrap">
									<div className="left-box">
										{items?.length ? (
											items.map((item, key) => (
												<>
													<Link
														to={`/blog/${item?.ID}`}
														className="card-box"
														key={key}
													>
														<div className="article-card">
															<div className="cardimgbox">
																<div
																	className="article-img"
																	style={{
																		backgroundImage: `url(${
																			item?.thumbnail || '/images/no-image.png'
																		})`,
																	}}
																></div>
															</div>
															<div className="text-box">
																<div className="tag-box">
																	{item?.tags?.length
																		? item?.tags?.map((i, k) => (
																				<>
																					<p className="cate" key={k}>
																						#{i?.name}
																					</p>
																				</>
																		  ))
																		: null}
																</div>
																<h3>{item?.postTitle}</h3>
																<p className="content">{item?.postContent}</p>
																<div className="flex">
																	<div className="user-box">
																		<div
																			className="user"
																			style={{
																				backgroundImage: `url(${item?.postAuthorImg})`,
																			}}
																		></div>
																		{item.isAuthorName ? (
																			<>
																				<div
																					className="user"
																					style={{
																						backgroundImage: `url(${item?.postAuthorImg})`,
																					}}
																				></div>
																				<div
																					className="user"
																					style={{
																						backgroundImage: `url(${item?.postAuthorImg})`,
																					}}
																				></div>
																			</>
																		) : null}
																	</div>
																	{item.isAuthorName ? null : (
																		<p>{item.postAuthorName}</p>
																	)}
																	{item.series ? (
																		<p className="name">
																			<img
																				src="/images/icon-lightning.svg"
																				alt=""
																			/>
																			{item?.series}
																		</p>
																	) : null}
																	<p className="date">{item?.postDate}</p>
																</div>
															</div>
														</div>
													</Link>
													<div className="line"></div>
												</>
											))
										) : items ? (
											'로딩중'
										) : (
											<div className="result">
												<div className="result-box">
													<p>
														등록된 게시글이 없어요
														<br /> 게시글을 등록해보세요!
													</p>
												</div>
											</div>
										)}
									</div>
								</div>
							</div>
						) : (
							<>
								<SkeletonList />
								<SkeletonList />
								<SkeletonList />
								<SkeletonList />
								<SkeletonList />
								<SkeletonList />
								<SkeletonList />
								<SkeletonList />
							</>
						)}
						<Pagination
							total={total}
							postsPerPage={postsPerPage}
							paged={paged}
							maxPaged={maxPaged}
							onPaging={onPaging}
						/>
					</div>
					<div className="mo-banner-wrap">
						{1 ? (
							<div
								className="mo-banner"
								style={{ backgroundImage: `url(/images/mo-banner.png)` }}
							>
								<p className="title">
									새로운 금융IT 세상을 만들어갈 인재를 모십니다.
								</p>
								<a href="https://kbds.career.greetinghr.com/" target="_blank">
									<span>
										채용공고 보러가기
										<img src="/images/icon-banner-more.svg" alt="" />
									</span>
								</a>
							</div>
						) : (
							<SkeletonMoBanner />
						)}
						<div className="line"></div>
					</div>
					{tags?.length ? (
						<div className="right">
							<div className="series">
								<h3>추천 포켓</h3>
								<div className="series-list">
									{seriesNum?.length ? (
										shuffleArray(seriesNum)
											.slice(0, 3)
											.map((item, key) => (
												<div className="list" key={key}>
													<Link to={`/blog/series/${item.key}`}>
														<div
															className="seriesimg"
															style={{
																backgroundImage: `url(${shuffle[key]?.moThumbnail})`,
															}}
														></div>
														<div className="text-box">
															<h4>{item?.title}</h4>
															<p>게시글 {item?.value}개</p>
														</div>
													</Link>
												</div>
											))
									) : (
										<></>
									)}
								</div>
							</div>
							<div className="tag">
								<h3>최근 가장 인기있는 태그</h3>
								<ul>
									{tags.map((item, key) => (
										<Link to={`/tag/${item?.value?.name}`}>
											<li key={key}>#{item?.value?.name}</li>
										</Link>
									))}
								</ul>
							</div>
						</div>
					) : (
						<SkeletonSeriesWrap />
					)}
				</div>
				<BannerWrapper>
					{tags?.length ? (
						<div
							className="banner"
							style={{ backgroundImage: `url(/images/banner-img02.png)` }}
						>
							<p className="title">
								새로운 금융IT 세상을 만들어갈 인재를 모십니다.
							</p>
							<a href="https://kbds.career.greetinghr.com/" target="_blank">
								<span>
									채용공고 보러가기
									<img src="/images/icon-banner-more.svg" alt="" />
								</span>
							</a>
						</div>
					) : (
						<SkeletonBanner />
					)}
				</BannerWrapper>
			</Wrapper>
		</Layout>
	);
};

export default Writer;
